import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class BillingPackage extends FirebaseModel {
	static entity = 'billingPackages';
	static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('packages');
	static fields(){
		return {
			name: this.attr(null),
			quick_books_name: this.attr(null),
			is_customer: this.attr(null),
			sample_category_uuid: this.attr(null),
			priority: this.attr(null),
			has_tests: this.attr(null),
			has_flags: this.attr(null),
			is_qa_only: this.attr(false),
			additional_cost: this.attr(null),
			...super.fields()
		}
	}
}
